module.exports = __webpack_public_path__ + "img/0-05.9a253cdd.jpg";